export class Job {
    id: number;
    ConsignmentNo: string;
    Pickup_Start: string;
    Delivery_Start: string;
    PUCompanyName: string;
    PUAddress: string;
    PUState: string;
    PUSuburb: string;
    PUPostcode: string;
    DelCompanyName: string;
    DelAddress: string;
    DelState: string;
    DELSuburb: string;
    DelPostcode: string;
    VehicleID: string;
    DriverName: string;
    TankerDescription: string;
    Delivery_End: string;
    PUCoordinate: string;
    DELCoordinate: string;
    CarrierReferenceNumber: string;
    Customer_Reference: string;
    Customer_Field1: string;
    Customer_Field2: string;
    Customer_Field3: string;
    CustCode: string;
    Depot: string;
    Product: string;
    Qty: number;
    JobStatus: string;
    constructor(job?) {
        this.id = job? job.id : null;
        this.ConsignmentNo = job? job.ConsignmentNo: '';
        this.Pickup_Start = job? job.Pickup_Start : '';
        this.Delivery_Start = job? job.Delivery_Start :  '';
        this.PUCompanyName = job? job.PUCompanyName :  '';
        this.PUAddress = job? job.PUAddress : '';
        this.PUState = job? job.PUState :  '';
        this.PUSuburb = job? job.PUSuburb :  '';
        this.PUPostcode = job? job.PUPostcode :  '';
        this.DelCompanyName = job? job.DelCompanyName : '';
        this.DelAddress = job? job.DelAddress :  '';
        this.DelState = job? job.DelState :  '';
        this.DELSuburb = job? job.DELSuburb :  '';
        this.DelPostcode = job? job.DelPostcode :  '';
        this.VehicleID = job? job.VehicleID :  '';
        this.DriverName = job? job.DriverName :  '';
        this.TankerDescription = job? job.TankerDescription :  '';
        this.Delivery_End = job? job.Delivery_End :  '';
        this.PUCoordinate = job? job.PUCoordinate :  '';
        this.DELCoordinate = job? job.DELCoordinate :  '';
        this.CarrierReferenceNumber = job? job.CarrierReferenceNumber :  '';
        this.Customer_Reference = job? job.Customer_Reference :  '';
        this.Customer_Field1 = job? job.Customer_Field1 :  '';
        this.Customer_Field2 = job? job.Customer_Field2 :  '';
        this.Customer_Field3 = job? job.Customer_Field3 :  '';
        this.CustCode = job? job.CustCode :  '';
        this.Depot = job? job.Depot : '';
        this.Product = job? job.Product :  '';
        this.Qty = job? job.Qty : 0;
        this.JobStatus = job? job.JobStatus :  '';
    }
    getPickupAddress(): string {
        return  this.PUAddress + ', ' + this.PUSuburb + ' ' + this.PUState + ' ' + this.PUPostcode;       
    }

    getDeliveryAddress(): string {
        return  this.DelAddress + ', ' + this.DELSuburb + ' ' + this.DelState + ' ' + this.DelPostcode;       
    }
}
export class JobScheduleHistory {
    Date_Created: Date;
    comment: string;
    newDeliveryTime: Date;
    newPickupTime: Date;
    originDeliveryTime: Date;
    originPickupTime: Date;
}


// WEBPACK FOOTER //
// ./src/model/job.ts